module.exports = __webpack_public_path__ + "static/media/galerija_2017 (21).a8898c56.jpg";